import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { SelectRoadComponent } from './modules/select-road/select-road.component';
import { RoadSelectedGuard } from './core/guards/road-selected';
import { NoRoadSelectedGuard } from './core/guards/no-road-selected';
import { RoleGuard } from './core/guards/role.guard';

export const routes: Routes = [
  {
    path: '',
    component: SelectRoadComponent,
    canActivate: [MsalGuard, NoRoadSelectedGuard],
  },
  {
    path: 'center-activity',
    loadComponent: () =>
      import('./modules/center-activity/center-activity.component').then(
        (m) => m.CenterActivityComponent,
      ),
    canActivate: [MsalGuard, RoadSelectedGuard],
  },
  {
    path: 'kpi-historical',
    loadComponent: () =>
      import('./modules/kpi-historical/kpi-historical.component').then(
        (m) => m.KpiHistoricalComponent,
      ),
    canActivate: [MsalGuard, RoadSelectedGuard],
  },
  {
    path: 'evaluation-reporting',
    loadComponent: () =>
      import('./modules/evaluation-reporting/evaluation-reporting.component').then(
        (m) => m.EvaluationReportingComponent,
      ),
    canActivate: [MsalGuard, RoadSelectedGuard],
  },
  {
    path: 'roads',
    loadComponent: () =>
      import('./modules/admin/roads/roads.component').then((m) => m.RoadsComponent),
    canActivate: [MsalGuard, RoadSelectedGuard, RoleGuard],
    data: {
      roles: ['admin', 'coordinador'],
    }, // Ejemplo: roles requeridos para esta ruta
  },
  {
    path: 'messages',
    loadComponent: () =>
      import('./modules/admin/messages/messages.component').then((m) => m.MessagesComponent),
    canActivate: [MsalGuard, RoadSelectedGuard, RoleGuard],
    data: {
      roles: ['admin', 'coordinador'],
    }, // Ejemplo: roles requeridos para esta ruta
  },
  {
    path: 'kits',
    loadComponent: () => import('./modules/admin/kits/kits.component').then((m) => m.KitsComponent),
    canActivate: [MsalGuard, RoadSelectedGuard, RoleGuard],
    data: {
      roles: ['admin', 'coordinador'],
    }, // Ejemplo: roles requeridos para esta ruta
  },
  {
    path: 'pictograms',
    loadComponent: () =>
      import('./modules/admin/pictograms/pictograms.component').then((m) => m.PictogramsComponent),
    canActivate: [MsalGuard, RoadSelectedGuard, RoleGuard],
    data: {
      roles: ['admin'],
    },
  },
];
